import { gql } from '@apollo/client'

export const EXPORT_SPECIAL_INGREDIENTS_QUERY = gql`
  query TaxonomySpecialFunctionalUnits($first: Int, $after: String) {
    taxonomySpecialFunctionalUnits(first: $first, after: $after) {
      nodes {
        id
        code
        name
        state
        class
        category
        categoryId
        functionalUnit
        functionalUnitProxy
        transportCondition
        isVerified
        verifiedOn
        lastPublishedDate
        lastUpdatedName
        updated
        researcherName
        researcherEmail
        created
        userEmail
        verificationComments
        verifiedByName
        verifiedByEmail
        storageFoodCategory
        storageDurationInHours
        storageReferenceLink
        secondaryDataReferenceSourceType
        referenceAuthorName
        referenceLink
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        dataQualityComment
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
